import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { CounterComponent } from './counter/counter.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { HeaderComponent } from './shared/partials/header/header.component';
import { FooterComponent } from './shared/partials/footer/footer.component';
import { OrderComponent } from './order/order.component';
import { CcPaymentReportComponent } from './cc-payment-report/cc-payment-report.component';
import { ClassSummaryComponent } from './class-summary/class-summary.component';
import { ContentManagementComponent } from './content-management/content-management.component';
import { CustomerComponent } from './customer/customer.component';
import { DevicesComponent } from './devices/devices.component';
import { DriversComponent } from './drivers/drivers.component';
import { EmployeeComponent } from './employee/employee.component';
import { UserManagementComponent } from './user-management/user-management.component';
import { AppRoutingModule } from './app-routing.module';
import { TagReportComponent } from './tag-report/tag-report.component';
import { DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaskModule, IConfig } from 'ngx-mask'
import { MustMatchDirective } from './shared/directives/must-match.directive';
import { OnlynumberDirective } from './shared/directives/onlynumber.directive';
import { ChangePasswordComponent } from './drivers/change-password/change-password.component';
import { HttpInterceptorService } from './shared/services/http-interceptor.service';
import { BlockUIModule } from 'ng-block-ui';
import { CustomerProfileComponent } from './customer/customer-profile/customer-profile.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { CookieService } from 'ngx-cookie-service';
import { AddEmployeeComponent } from './employee/add-edit-employee/add-employee.component';
import { ReferralSummaryComponent } from './referral-summary/referral-summary.component';
import { CustomerTransactionDetailsComponent } from './customer/customer-transaction-details/customer-transaction-details.component';


const maskConfigFunction: () => Partial<IConfig> = () => {
  return {
    validation: false,
  };
};


@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    CounterComponent,
    FetchDataComponent,
    HeaderComponent,
    FooterComponent,
    OrderComponent,
    CcPaymentReportComponent,
    ClassSummaryComponent,
    ContentManagementComponent,
    CustomerComponent,
    DevicesComponent,
    DriversComponent,
    EmployeeComponent,
    UserManagementComponent,
    TagReportComponent,
    AddEmployeeComponent,
    MustMatchDirective,
    OnlynumberDirective,
    ChangePasswordComponent,
    CustomerProfileComponent,
    ReferralSummaryComponent,
    CustomerTransactionDetailsComponent,

  ],
  imports: [
    AppRoutingModule,
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    NgbModule,
    NgxMaskModule.forRoot(maskConfigFunction),
    BlockUIModule.forRoot(),
    ToastrModule.forRoot(),
    AngularEditorModule,
  ],
  exports: [],
  providers: [ CookieService, 
   [{ provide : HTTP_INTERCEPTORS, useClass : HttpInterceptorService, multi : true}],
    [Location, { provide: LocationStrategy, useClass: HashLocationStrategy }],  
  ],
  bootstrap: [AppComponent],
  entryComponents: [CustomerProfileComponent, ChangePasswordComponent]
})
export class AppModule { }
